import {IModalService, IModalSettings} from 'angular-ui-bootstrap';
import IPromise = angular.IPromise;

require('./dv-dialog.scss');

export class DvDialog {

    static $inject: any[] = ['$uibModal'];
    /* @ngInject */
    constructor(private $uibModal: IModalService) {
    }


    public showDialog(template: string, controller?: any, params?: any): IPromise<any> {

        let options: IModalSettings = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            resolve: {
                title: () => params.title,
                text: () => params.text,
            }
        };

        return this.$uibModal.open(options).result;
    };
    public showBerechnungsDetail(template: string, controller?: any, params?: any): IPromise<any> {

        let options: IModalSettings = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            resolve: {
                einkommensabzug: () => params.einkommensabzug,
                vermoegensabzug: () => params.vermoegensabzug,
                anrechenbarerschaden: () => params.anrechenbarerschaden,
                minimalschaden: () => params.minimalschaden,
                steuerbaresvermoegen: () => params.steuerbaresvermoegen,
                steuerbareseinkommen: () => params.steuerbareseinkommen
            }
        };

        return this.$uibModal.open(options).result;
    };

    public showMapDialog(template: string, controller?: any, params?: any): IPromise<any> {

        let options: IModalSettings = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            windowClass: 'map-modal-window',
            resolve: {
                lat: () => params.lat,
                lon: () => params.lon,
                reado: () => params.readonly
            }
        };

        return this.$uibModal.open(options).result;
    };

    public showBemerkungDialog(template: string, controller?: any, params?: any): IPromise<any> {

        let options: IModalSettings = {
            template: template,
            controller: controller,
            bindToController: false,
            controllerAs: 'vm',
            windowClass: 'bemerkung-modal-window',
            resolve: {
                text: () => params.text,
                begrundungscodeOptions: () => params.begrundungscodeOptions,
                showBegruendung: () => params.showBegruendung,
                showBemerkung: () => params.showBemerkung,
            }
        };

        return this.$uibModal.open(options).result;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/directive/dv-dialog/dv-dialog.ts